class VwKurumbonustanimDTO {
    id: number = 0;
    fkKurumId?: number = null;
    oran?: number = null;
    bonusYontem?: number = null;
    aktif?: string = "E";
    ekleyenKullanici?: number = null;
    eklemeTarih?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptalTarihi?: string = null;
    iptalKullanici?: number = null;
    iptalNedenId?: number = null;
    iptalAciklama?: string = "";
    kurumAdi?: string = "";
};
export default VwKurumbonustanimDTO;